import { rem } from 'polished';
import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  border-radius: 16px;

  padding-left: ${rem(4)};
  margin: 0 0 ${rem(8)} 0;
`;

export const LoadingIconContainer = styled.div`
  width: ${({ theme }) => theme.typography.fontSizes.fontSize48};
  height: ${({ theme }) => theme.typography.fontSizes.fontSize48};
`;
